import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RowContainer = styled.div``

export const SubText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export const StrikethroughText = styled(Text)`
  text-decoration: line-through;
`
